import { DEFAULT_CONFIG } from "./constants";
import { ACTION_BUTTON_TYPE, LINK_BUTTON_TYPE } from "./types";
import { nodeViewRenderers } from "./viewer/nodeViewRenderers";
const pluginButton = (type, config) => {
  return {
    config: { ...DEFAULT_CONFIG, ...config },
    type,
    nodeViewRenderers
  };
};
const pluginLinkButton = (config) => {
  return pluginButton(LINK_BUTTON_TYPE, config);
};
const pluginActionButton = (config) => {
  return pluginButton(ACTION_BUTTON_TYPE, config);
};
export {
  pluginActionButton,
  pluginLinkButton
};
//# sourceMappingURL=viewer.js.map
